import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import InterRegular from "./Inter-Regular.woff2";
import InterSemiBold from "./Inter-SemiBold.woff2";
import InterBold from "./Inter-Bold.woff2";

export const InterFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: InterRegular,
    descriptors: {
      weight: "400",
      style: "normal",
    },
  },
  {
    uri: InterSemiBold,
    descriptors: {
      weight: "600",
      style: "normal",
    },
  },
  {
    uri: InterBold,
    descriptors: {
      weight: "700",
      style: "normal",
    },
  },
];
